module.exports = __webpack_public_path__ + "static/media/478SunsetAveNW_2018-06-06_59.1b0894c3.jpg";